import { createHttpLink } from 'apollo-link-http'
import fetch from 'node-fetch'

export default createHttpLink({
  uri: '/graphql',
  fetch: fetch
})
